var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { capitalize } from '@sonar-software/sonar-ts-lib';
import { FilterContainer } from './FilterContainer';
import { FilterTag } from './FilterTag';
import React from 'react';
export const FilterComponent = (_a) => {
    var _b, _c;
    var { children, className, tagProps } = _a, props = __rest(_a, ["children", "className", "tagProps"]);
    if (props.displayAsTag) {
        return (React.createElement(FilterTag, Object.assign({ clearValue: Array.isArray(props.value) ? [] : '', format: props.format, id: props.id, label: capitalize((_b = props.label) !== null && _b !== void 0 ? _b : ''), update: props.onChange, value: props.value }, (tagProps !== null && tagProps !== void 0 ? tagProps : {}))));
    }
    return (React.createElement(FilterContainer, { className: className, label: (_c = props.label) !== null && _c !== void 0 ? _c : '' }, children));
};
